<template>
  <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Tên tuần học')"
                  v-model.trim="item.weekName"
                  name="weekName"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('weekName')"
                  :data-vv-as="$t('Tên tuần học')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Số thứ tự tuần')"
                  v-model.trim="item.weekOrder"
                  name="weekName"
                  v-validate="'required|numeric'"
                  maxLength="250"
                  :error-messages="errors.first('weekOrder')"
                  :data-vv-as="$t('Số thứ tự tuần')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="units"
                  :label="$t('Tên bài')"
                  v-model="item.unitId"
                  name="unitId"
                  item-value="unitId"
                  item-text="unitName"
                  v-validate="'required'"
                  :data-vv-as="$t('Level')"
                  :error-messages="errors.first('unitId')"
                  :disabled="item.pondId ? true : false"
                  v-on:change="levelChange(item.unitId)"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="missions"
                  :label="$t('Tên nhiệm vụ')"
                  v-model="item.missionId"
                  name="missionId"
                  item-value="missionId"
                  item-text="missionName"
                  v-validate="'required'"
                  :data-vv-as="$t('Độ tuổi')"
                  :error-messages="errors.first('missionId')"
                  :disabled="item.pondId ? true : false"
                  v-on:change="levelChange(item.missionId)"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";

export default {
  name: "material-type-group-create",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },
    units: {
      type: Array,
      default: [],
    },

    missions: {
      type: Array,
      default: [],
    },

    ages: {
      type: Array,
      default: [],
    },
  },
  data: () => {
    return {
      areaStatus: areaContants.areaStatus,
      item: {
        weekOrder: "",
        weekName: "",
        unitId: "",
        missionId: "",
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        //console.log(value);
        if (value !== null) {
          this.item = {
            weekId: value.weekId,
            weekName: value.weekName
                ? value.weekName
                : "",
            weekOrder: value.weekOrder
                ? value.weekOrder
                : "",
            programId: this.$route.params.id,
            order: value.order
                ? value.order
                : "",
            unitId: value.unitId
                ? value.unitId
                : "",
            missionId: value.missionId
                ? value.missionId
                : "",
            status: value.status ? value.status : 0,
          };
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      this.item = {
        weekOrder: "",
        weekName: "",
        unitId: "",
        missionId: "",
      };
    },
    levelChange(levelId) {
      this.getNextCode();
    },
    getNextCode: function () {
      axios.post(
          process.env.VUE_APP_API_URL + "/kidLevel/listAllName", {status: 1}
      )
          .then((data) => {
            this.item = Object.assign({}, this.item, {"code": data})
          });
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      // console.log(this.item);
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/kidWeek/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    if (data.description === 'lang.category.duplicateCode') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    } else if (data.description === 'lang.category.duplicateName') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    }
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
    // kidLevel
    axios.post(
        process.env.VUE_APP_API_URL + "/kidUnit/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.units = data;
              }
            }
        );

    // kidAge
    axios.post(
        process.env.VUE_APP_API_URL + "/kidMission/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.missions = data;
              }
            }
        );

  },
};
</script>
